<div class="chip btn {{ customClass }}" [attr.contenteditable]="editing" #chipContainer>
  <ng-content></ng-content>
</div>
